import { CSSProperties } from 'react';
import { Size } from '@vivli/shared/theme';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';

const containerStyle: CSSProperties = {
    overflowX: 'hidden',
    overflowY: 'auto',
    marginTop: '-100px',
    paddingTop: 100,
    paddingLeft: Size.INSET_SIZE,
    paddingRight: Size.INSET_SIZE,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 10,
    background: 'white',
};

const singleLineContainerStyle: CSSProperties = {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: 'repeat(auto-fit, minmax(0, 1fr))',
    paddingBottom: 0,
    paddingTop: Size.INSET_SIZE / 2.8,
    color: 'darkblue',
};

const singleLineHeaderStyle: CSSProperties = {
    fontWeight: 'bold',
    marginRight: '10px',
};

interface PublishingConfigFormComponentProps {
    dataRequest: IDataRequest;
}

export const PublishingConfigFormComponent = ({ dataRequest }: PublishingConfigFormComponentProps) => {
    const domain = window.location.origin;
    const doiStemId = dataRequest.secondaryAnalysisDoi?.split('/')[4];
    const landingPageUrl = `${domain}/doiLanding/dataRequests/${doiStemId}`;

    return (
        <div style={containerStyle}>
            <div style={singleLineContainerStyle}>
                <span style={singleLineHeaderStyle}>Data Request Landing Page:</span>
                <a href={landingPageUrl} target="_blank" rel="noopener noreferrer" data-test-id="data-request-landing-page-anchor">
                    {landingPageUrl}
                </a>
            </div>
            <div style={singleLineContainerStyle}>
                <span style={singleLineHeaderStyle}>Data Request DOI:</span>
                <a
                    href={dataRequest.secondaryAnalysisDoi}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-test-id="secondary-analysis-anchor"
                >
                    {dataRequest.secondaryAnalysisDoi}
                </a>
            </div>
        </div>
    );
};
